import {html} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import {FlywheelComponent} from '../../lib/component.js';
import exampleStyles from './style.scss';

// Used as the tag's name when registering the element.
export const EXAMPLE_COMPONENT_TAG = 'fly-example';

/**
 * ExampleComponent -- Comments are required for describing the funcitonality of every
 * component.
 */
@customElement(EXAMPLE_COMPONENT_TAG)
export default class ExampleComponent extends FlywheelComponent {
  @property()
  text = ''; // Example string prop

  @property({type: Boolean})
  bool = false; // Example boolean prop

  /**
   * Retrieves example styles.
   */
  static get styles() {
    return [exampleStyles];
  }

  /**
    Reactively renders HTML in the ShadowDOM.
   * @override
   */
  render() {
    return html`
      <div class="example-class">
        ${!this.bool ? html`<h1>${this.text}</h1>` : ''}
        <button @click=${() => (this.bool = !this.bool)}>Flip</button>
      </div>
    `;
  }
}
